import moment from "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilState, useRecoilValue } from "recoil";
import { resetRecoil, setRecoil } from "recoil-nexus";
import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import { ConciergeRequestType } from "../../controller/ConciergeController";
import LogController from "../../controller/LogController";
import { useToast } from "../../controller/ToastController";
import { authState, masterStoreState } from "../../recoil/auth";
import { LANG_KO, langState, langText } from "../../recoil/lang";
import { showKeyboardState } from "../../recoil/showKeyboard";
import { conciergeState } from "../../recoil/socket";
import "../../styles/CustomModal.css";

const ConciergeRequestModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  conciergeRequestData: ConciergeRequestType[];
  conciergeFlag: any;
}) => {
  const showToast = useToast();
  const auth = useRecoilValue(authState);
  const master = useRecoilValue(masterStoreState);
  const chatEndRef = useRef<HTMLDivElement | null>(null);

  const textareaRef = useRef<any>(null);

  const [lang, setLang] = useRecoilState<number>(langState);
  const [message, setMessage] = useState<string>("");
  const [showKeyboard, setShowKeyboard] = useRecoilState(showKeyboardState);
  const [requestData, setRequestData] = useState<ConciergeRequestType[]>(
    oProps.conciergeRequestData
  );

  const scrollToBottom = () => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const changeMessage = (e: any) => {
    setMessage(e.target.value);
  };

  const onCloseModal = () => {
    oProps.setVisible(false);
    setRecoil(conciergeState, (prev) => ({ ...prev, isChat: false }));
  };

  // 컨시어지 요청
  const writeMessage = async () => {
    if (message === "") {
      showToast(langText.responseModal_input_placeholder[lang], "error");
    } else {
      try {
        const oParams = {
          concierge_id: oProps.conciergeFlag.concierge_id,
          message: message,
          accessor: "CLIENT",
          lang: lang,
          user_id: auth.user_id,
        };
        setMessage("");

        const response = await ApiController.concierge.writeMessage(oParams);

        if (response && response.data.success) {
          const newMessage = {
            concierge_check_status: 0,
            content: message,
            created_at: new Date().toISOString(),
            request_from: 1,
          };
          setRequestData([...requestData, newMessage]);
          scrollToBottom();
        } else {
          showToast(langText.responseModal_failed[lang], "error");
        }
      } catch (err) {
        console.log("writeMessage err-->", err);
      }
    }
  };
  const conciergeFinish = async () => {
    try {
      const oParams = {
        concierge_id: oProps.conciergeFlag.concierge_id,
      };
      const response = await ApiController.concierge.conciergeFinish(oParams);

      if (response && response.data) {
        oProps.setVisible(false);
        showToast(langText.finish_chat[lang]);
        resetRecoil(conciergeState);

        LogController.click({
          path: "ConciergeRequestModal",
          params: "concierge",
          params2: "채팅 종료 버튼 클릭",
          index: oProps.conciergeFlag.concierge_id,
        });
      }
    } catch (err) {
      console.log("conciergeFinish err-->", err);
    }
  };

  useEffect(() => {
    setRequestData(oProps.conciergeRequestData);
    scrollToBottom();
  }, [oProps.conciergeRequestData]);
  useEffect(() => {
    setMessage(showKeyboard.input);
  }, [showKeyboard]);
  useEffect(() => {
    setMessage("");
  }, [oProps.isVisible]);
  useEffect(() => {
    scrollToBottom();
  }, [requestData]);

  useEffect(() => {
    const textarea = textareaRef.current;

    if (textarea) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [message]);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        modal: "conciergeModal",
      }}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <div className="modal_header">
            <div className="cleckButton">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_clerk.svg`}
                width={48}
                height={48}
                alt="컨시어지 아이콘"
              />
            </div>
            {master && (
              <h2>
                {lang === LANG_KO ? master.store_name : master.store_name_en}
              </h2>
            )}
            <img
              className="closeIcon"
              onClick={onCloseModal}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
              alt="닫기 아이콘"
            />
          </div>
          <div className="modal_content">
            <div className="chatWrap">
              {requestData &&
                requestData.map((data: ConciergeRequestType, index: number) => (
                  <div
                    key={index}
                    className={` sendWrap${
                      data.request_from === 0 ? " hotel" : " customer"
                    }`}
                  >
                    {data.request_from === 0 && (
                      <div className="iconBox">
                        <img
                          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_clerk.svg`}
                          width={18}
                          height={18}
                          alt="컨시어지 아이콘"
                        />
                      </div>
                    )}
                    {data.request_from === 1 && (
                      <h4>{`${
                        new Date(data.created_at).getHours() > 12
                          ? langText.pm[lang]
                          : langText.am[lang]
                      } ${moment(new Date(data.created_at)).format(
                        "HH:mm"
                      )}`}</h4>
                    )}
                    <p>{data.content}</p>
                    {data.request_from === 0 && (
                      <h4>{`${
                        new Date(data.created_at).getHours() > 12
                          ? langText.pm[lang]
                          : langText.am[lang]
                      } ${moment(new Date(data.created_at)).format(
                        "HH:mm"
                      )}`}</h4>
                    )}
                  </div>
                ))}
              <div ref={chatEndRef} style={{ marginBottom: "50px" }} />
            </div>
            <div className="textAreaWrap">
              {lang === 0 ? (
                <textarea
                  ref={textareaRef}
                  name="conciergeText"
                  id="conciergeText"
                  placeholder={langText.responsBox[lang]}
                  value={message}
                  onChange={(e) => changeMessage(e)}
                ></textarea>
              ) : (
                <div
                  ref={textareaRef}
                  onClick={() =>
                    setShowKeyboard((prev) => ({
                      ...prev,
                      showKeyboard: true,
                      input: message,
                    }))
                  }
                  className="textarea"
                  id="conciergeText"
                >
                  {message}
                </div>
              )}
              <button onClick={writeMessage} className="sendButton">
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_send.svg`}
                  alt="보내기 아이콘"
                />
              </button>
            </div>
          </div>
          <div style={{ height: "5px", background: "#1C1C1C" }} />
          <div className="modal_footer">
            <div className="noticeText">
              <p>{langText.responseModal_comment[lang]}</p>
            </div>
            <button onClick={conciergeFinish}>
              {langText.responseModal_button_check[lang]}
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ConciergeRequestModal;

const Style = styled.div`
  .modal {
    width: 100%;
    height: 100%;
  }

  /* modal_header */
  .modal_header {
    width: 100%;
    min-height: 200px;
    padding: 74px 0 34px 0;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    h2 {
      /* font-size: 24px; */
      font-size: 28px;
      line-height: 36px;
      color: #ffffff;
    }

    .closeIcon {
      position: absolute;
      top: 6%;
      right: 2%;
      cursor: pointer;
    }
  }

  /* modal_content */
  .modal_content {
    width: 100%;
    padding: 0 5%;
  }
  .chatWrap {
    max-height: 300px;
    padding: 10px 32px;
    overflow-y: auto;
    border: 2px solid #555;
    border-radius: 10px;
    display: inline-flex;
    flex-direction: column;
    width: 100%;

    h4 {
      font-size: 12px;
      font-weight: 500;
      color: #737373;
      margin-top: auto;
    }
  }
  .sendWrap {
    width: auto;
    margin: 10px 0;
    display: flex;
    align-items: center;
    gap: 6px;

    p {
      max-width: 70%;
      padding: 6px 20px;
      background: #737373;
      border-radius: 20px;
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;
    }
  }
  .sendWrap.customer {
    justify-content: flex-end;
    p {
      background: #40977f;
    }
  }
  .iconBox {
    padding: 6px 7px 3px 7px;
    border-radius: 50px;
    background: #737373;
  }

  .textAreaWrap {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 30px 0;

    textarea,
    .textarea {
      flex: 1;
      padding: 6px 24px;
      background: #555;
      border-radius: 10px;
      border: none;
      outline: none;
      min-height: 40px;
      max-height: 40px;
      color: #979797;
      overflow: auto;
      white-space: pre-wrap;
      word-break: break-all;
      font-size: 18px;
      line-height: 24px;
    }
  }

  /* modal_footer */
  .modal_footer {
    padding: 37px 5% 58px 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .noticeText {
      margin-bottom: -12px;
      padding: 6px 16px 4px 16px;
      background: #f7f7f7;
      border-radius: 50px;
      z-index: 10;

      p {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: #ff4a4a;
        text-align: center;
      }
    }
    button {
      width: 100%;
      padding: 17px 0;
      font-size: 24px;
      font-weight: 600;
      color: #4dd2ae;
      border: 2px solid #4dd2ae;
      border-radius: 10px;
    }
  }

  /* 아이콘 */
  .cleckButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    margin-bottom: 27px;
    background: #4dd2ae;
    border-radius: 100px;
  }
  .sendButton {
    display: flex;
    align-items: center;
    padding: 8px 34px;
    border-radius: 10px;
    background: #4dd2ae;
  }

  .submitButton {
    margin-top: 10px;
    width: 100%;
    padding: 18px 0;
    background: #4dd2ae;
    border-radius: 10px;
    color: #ffffff;
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
  }
`;
